// extracted by mini-css-extract-plugin
export default {"proNotice":"ConvertToPro_proNotice__OJ2JT"};